import Typography from '@material-ui/core/Typography';
import i18n from 'i18next';
import * as PropTypes from 'prop-types';
import React from 'react';

export const localize = (key, options) => i18n.t(key, options);

/**
 * Localized text with custom typography
 * @param children children elements, all pure strings will be translated, components will be ignored
 * @param text text to translate if no Typography needs to be rendered
 * @param isTextLabel
 * @param suffix
 * @param props props for the typography elements (mainly variant and component)
 * @returns {*} Translated text with style
 */
const LocalizedText = ({ children, text, isTextLabel = false, suffix = '', ...props }) => (
  children ? (
    React.Children.map(children, (child) => {
      if (typeof child === 'string') {
        return (
          <Typography {...props}>
            {`${i18n.t(child)}${suffix}${isTextLabel ? ':' : ''}`}
          </Typography>
        );
      }
      return child;
    })
  )
    : `${i18n.t(text)}${suffix}`
);

LocalizedText.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  component: PropTypes.string,
  isTextLabel: PropTypes.bool,
  text: PropTypes.string,
  variant: PropTypes.string
};

LocalizedText.defaultProps = {
  children: null,
  component: 'p',
  text: null,
  variant: 'body1'
};

export default LocalizedText;